import { useEffect, useState } from "react";
import {
  CompanyGetCompanyStoreCompetitor,
  CompetitorFilterCategory,
  CompanySetCompanyStoreCompetitor,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function StoreCompetitor() {
  const [isLoading, setLoading] = useState(true);
  const [Competitors, setCompetitors] = useState([]);
  const [AccesCompetitor, setAccesCompetitor] = useState([]);

  const navigate = useNavigate();

  let { id, extra } = useParams();
  const start = async () => {
    try {
      if (extra) {
        const CompanyGetCompanyStoreCompetitorData =
          await CompanyGetCompanyStoreCompetitor(extra);
        if (
          CompanyGetCompanyStoreCompetitorData.status &&
          CompanyGetCompanyStoreCompetitorData.status === 200
        ) {
          var elemet = [];
          CompanyGetCompanyStoreCompetitorData.data.data.forEach(
            (element) => {
              elemet.push(element.competitorCategoryId);
            }
          );
          setAccesCompetitor(elemet);
        }

        const CompetitorFilterCategoryData = await CompetitorFilterCategory({});
        if (
          CompetitorFilterCategoryData.status &&
          CompetitorFilterCategoryData.status === 200
        ) {
          setCompetitors(CompetitorFilterCategoryData.data.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    try {
      const data = {
        CompetitorCategorysId: AccesCompetitor,
        CompanyStoreId: extra,
      };
      const CompanySetCompanyStoreCompetitorData =
        await CompanySetCompanyStoreCompetitor(data);
      if (
        CompanySetCompanyStoreCompetitorData.status &&
        CompanySetCompanyStoreCompetitorData.status === 200
      ) {
        toast.success("بروزرسانی با موفقیت انجام شد");
        navigate("/Panel/Companys/Store/" + id);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeInputCheckBox = async (e) => {
    var idAcees = e.target.id;
    let copy = [...AccesCompetitor];
    let check = copy.find((e) => e == idAcees);
    if (check) {
      copy = copy.filter((item) => item != e.target.id);
    } else {
      copy.push(e.target.id);
    }
    setAccesCompetitor(copy);
  };
  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <table className="table">
                  <thead className="sticky-header">

                  <tr className="trTable">
                    <th>دسترسی</th>
                    <th>نام</th>
                  </tr>
                </thead>
                <tbody className="identitystyle">
                  {Competitors &&
                    Competitors.map((item) => (
                      <tr>
                        <td>
                          <input
                            id={item.id}
                            type="checkbox"
                            onChange={handleChangeInputCheckBox}
                            checked={AccesCompetitor.find((e) => e == item.id)}
                          />
                        </td>
                        <td>{item.name}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                اعمال
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreCompetitor;
